export async function deleteOwners(dealerId: string, ownerId: number) {
  const url = `/internal-api/dealer/owners`;
  const body = {
    dealerId: parseInt(dealerId, 10),
    id: ownerId,
  };

  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Ошибка при удалении собственника: ", error);
    throw error;
  }
}
